import { render } from "./VersionNumber.vue?vue&type=template&id=e480eb7c"
import script from "./VersionNumber.vue?vue&type=script&lang=js"
export * from "./VersionNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__